import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { FuseCardComponent } from '@fuse/components/card';
import { TFMService } from 'app/mock-api/tfm.service';
import { HeadingSectionType01Component } from '../../heading-section/heading_section-type01/heading_section-type01.component';
import { NgClass, NgStyle } from '@angular/common';
import { RouterLink } from '@angular/router';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatDialog } from '@angular/material/dialog';
import { TeamModalComponent } from '../modals/teams-modal/team.component';

@Component({
  selector: 'app-about-type04',
  standalone: true,
  imports: [MatIconModule,FuseCardComponent,HeadingSectionType01Component, NgStyle, NgClass, RouterLink,MatTooltipModule],
  templateUrl: './about-type04.component.html',
  styleUrl: './about-type04.component.scss'
})
export class AboutType04Component implements OnInit {

  public view: any = {
    title: '',
    isModalOpen: false,
    selectedMember: null,
    teamMembers: [
      {
        id: 1,
        name: "Richard",
        image: "/assets/images/avatars/RD-295x300.jpg"
      },
      {
        id: 2,
        name: "Robyn",
        image: "/assets/images/avatars/Profile-pic-Robyn.jpg"
      },
      {
        id: 3,
        name: "Taryn",
        image: "/assets/images/avatars/Taryn-A-Pic-300x300.jpeg"
      },
      {
        id: 4,
        name: "Sandy",
        image: "/assets/images/avatars/sandy-295x300.png"
      },
    ]
  }

  openModal(member: any) {
    this.dialog.open(TeamModalComponent, {
      width: '400px',
      data: member
    });
  }


  constructor(public _tfmService: TFMService,private _cd: ChangeDetectorRef,public dialog: MatDialog) {
    
    this._tfmService.getContentBySection('about').then(res => {
      this.view.page = res;
      this._tfmService.log(this.view);

      if (this.view.page && this.view.page?.content?.images && this.view.page?.content?.images.length > 0) {
        const image = this.view.page?.content?.images[0]; // Access the first image object
        const links = image._links; // Access the _links array
      
        // Find the link with rel "view"
        const viewLink = links.find((link: any) => link.rel === "view");
      
        // Get the href if the view link exists
        if (viewLink) {
          this.view.imageHref = viewLink.href;
          this._tfmService.log("Image href:", this.view.imageHref);
          this._cd.detectChanges();
        } else {
          console.error("View link not found");
        }
      } else {
        console.error("Images not available");
      }
    });
    
    this._tfmService.getSite().then(res => {
        this.view.site = res;

        this.view.site.profile = this._tfmService.getSiteProfile(this.view.site.profileID);
        this._tfmService.log(this.view);
      });
      
  }

  ngOnInit(): void {
  }
}

